export function myQaAnswerListGet(page) {
	return {
    type: 'MY_QA_ANSWER_LIST_GET',
		payload: {
			page: page,
		},
	}
}
